export const GET_VALUETEC_SETUP_CONFIG_REQUESTED = 'brand/GET_VALUETEC_SETUP_CONFIG_REQUESTED';
export const GET_VALUETEC_SETUP_CONFIG_SUCCESS = 'brand/GET_VALUETEC_SETUP_CONFIG_SUCCESS';
export const GET_VALUETEC_SETUP_CONFIG_FAILURE = 'brand/GET_VALUETEC_SETUP_CONFIG_FAILURE';

export const UPDATE_VALUETEC_SETUP_CONFIG_REQUESTED = 'brand/UPDATE_VALUETEC_SETUP_CONFIG_REQUESTED';
export const UPDATE_VALUETEC_SETUP_CONFIG_SUCCESS = 'brand/UPDATE_VALUETEC_SETUP_CONFIG_SUCCESS';
export const UPDATE_VALUETEC_SETUP_CONFIG_FAILURE = 'brand/UPDATE_VALUETEC_SETUP_CONFIG_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  valueTecConfigData: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_VALUETEC_SETUP_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        valueTecConfigData: [],
      };
    }
    case GET_VALUETEC_SETUP_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        valueTecConfigData: action.result,
      };
    }
    case GET_VALUETEC_SETUP_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case UPDATE_VALUETEC_SETUP_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_VALUETEC_SETUP_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_VALUETEC_SETUP_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getValueTecData = (brandId) => {
  return {
    types: [GET_VALUETEC_SETUP_CONFIG_REQUESTED, GET_VALUETEC_SETUP_CONFIG_SUCCESS, GET_VALUETEC_SETUP_CONFIG_FAILURE],
    promise: client => client.get(`getValueTecConfig/${brandId}`)
  };
};

export const updateValueTecData = (brandId, data) => {
  return {
    types: [UPDATE_VALUETEC_SETUP_CONFIG_REQUESTED, UPDATE_VALUETEC_SETUP_CONFIG_SUCCESS, UPDATE_VALUETEC_SETUP_CONFIG_FAILURE],
    promise: client => client.post(`updateValueTecConfig/${brandId}`, { data })
  };
};
